
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'PlayButton'
})
export default class PlayButton extends Vue {}
